module.exports = __webpack_public_path__ + "static/media/crm_temp_opened.ed4e0948.svg";